import { Flex, Pill, Truncate } from '@eleveo/components-react';
import { CircleIcon } from '@eleveo/icons-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { REQUESTS_PROPS, REQUEST_STATE_PROPS } from '../config/agentsRequests';
import { RequestState, RequestSubtype } from '../graphql/components';

export const RequestStatusComponent = ({ status, testId }: { status: RequestState; testId?: string }) => {
  const { t } = useTranslation();

  const { color, icon, nameKey } = REQUEST_STATE_PROPS[status];

  return (
    <Pill color={color} testId={testId} variant={status === RequestState.Approved ? 'outline' : 'solid'}>
      {icon}
      <Truncate>{t(nameKey)}</Truncate>
    </Pill>
  );
};

export const RequestSubtypeComponent = ({ testId, type }: { testId?: string; type: RequestSubtype }) => {
  const { t } = useTranslation();

  const { color, nameKey } = REQUESTS_PROPS[type];

  return (
    <Flex as="span" alignItems="baseline" gap={10} inline testId={testId}>
      <CircleIcon
        className="text-sm"
        style={{
          color, // Contains HEXa value representing corresponding schedule element's color (which is yet out of defined New design system color palette)
        }}
      />
      <strong>{t(nameKey)}</strong>
    </Flex>
  );
};
